import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import {
  HeaderSite,
  HeaderContainer,
  MenuDesktop,
  GradientLine,
  Circle
} from './styles';
import {
  ArrowBack,
  IconCheck
} from '../../../assets/icons';

import LogoEinstein from '../../../assets/logo.png';

type props = Readonly<{
  step: string
  handleStep: Function
}>;
export default function Header(props: props): ReactElement {
  const getPaymentMenuClass = () => {
    if (props.step === 'paymentMethod' || props.step === 'paymentData') return 'menu-item actual';
    if (props.step === 'userData') return 'menu-item past';
    return 'menu-item';
  };

  const getPaymentCircleClass = () => {
    if (props.step === 'paymentMethod' || props.step === 'paymentData') return 'actual-number';
    if (props.step === 'userData') return 'actual-circle';
    return '';
  };

  const getPaymentArrowClass = () => {
    if (props.step === 'email' || props.step === 'login') return 'arrow';
    if (props.step === 'userData') return 'arrow past';
    return 'arrow actual';
  };

  return (
    <HeaderSite>
      <HeaderContainer>
        <Link to="/">
          <img src={LogoEinstein} width={'200px'} alt="" />
        </Link>
          <MenuDesktop>
            <button onClick={() => props.handleStep('email')}>
              <div className={props.step === 'email' || props.step === 'login' ? 'menu-item actual' : 'menu-item past'}>
                <Circle className="actual-circle">
                  <IconCheck />
                </Circle>
                <span className="text">Login ou cadastro</span>
              </div>
            </button>
            <div className={props.step === 'email' || props.step === 'login' ? 'arrow actual' : 'arrow past'}>
              <ArrowBack />
            </div>

            <button onClick={() => props.handleStep('paymentMethod')}>
              <div
                className={getPaymentMenuClass()}
                >
                <Circle
                  className={getPaymentCircleClass()}
                  >
                  { props.step === 'userData' ? (<IconCheck />) : '2'}
                </Circle>
                <span className="text">Pagamento</span>
              </div>
            </button>
            <div className={getPaymentArrowClass()}>
              <ArrowBack />
            </div>

            <div className={props.step === 'userData' ? 'menu-item actual' : 'menu-item'}>
              <Circle className={props.step === 'userData' ? 'actual-number' : ''}>3</Circle>
              <span className="text">Dados do beneficiário</span>
            </div>
          </MenuDesktop>
      </HeaderContainer>
      <GradientLine />
    </HeaderSite>
  );
}
